<style lang="scss">
.m5.slide-4 {
  background-image: url(../../../assets/module5/slide4/bg-05.jpg);
  background-size: cover;
  background-position: center;
  height: calc(100% - 100px);
  padding: 50px 0;
  .page-left {
    flex-basis: 70%;
    padding-top: 75px;
  }
  .page-right {
    flex-basis: 30%;
  }

  h1 {
    color: #3b7fc2;
    font-size: 100px;
    line-height: 95px;
    margin-top: 50px;
    span {
      display: block;
      &:first-child {
        transform: translateX(-50px);
      }
      &:last-child {
        transform: translateX(150px);
      }
    }
  }
  .heading2 {
    transform: rotate(-4deg) translateX(-50px);
    color: #2e1d46;
    margin-top: 0;
  }

  .copy {
    color: #000;
    width: 60%;
    margin-left: auto;

    &:nth-child(1) {
      margin-top: 50px;
    }
  }
  p {
    color: #000;
    max-width: 680px;
    &.para2 {
      max-width: 600px;
      margin-top: 50px;
    }
  }
  .download {
    width: 140px;
    display: block;
    cursor: pointer;
    transition: all 0.2s ease-out;
    margin-left: 115px;
    margin-top: 40px;
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>

<template>
  <div class="m5 slide-4">
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 3"
        src="@/assets/module5/slide4/poster-05.png"
        class="chars delay-1"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 3"
        src="@/assets/module5/slide4/scissor-05.png"
        class="chars delay-2"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 3"
        src="@/assets/module5/slide4/timmy-05.png"
        class="chars delay-2"
      />
    </transition>

    <div class="pages">
      <div class="page page-left">
        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 3">
            <p>{{ $t("module5.slide4.paragraph1") }}</p>
          </div>
        </transition>
        <transition name="scale" appear>
          <div class="delay-1" v-show="slideIndex == 3">
            <h1 class="heading1" v-html="$t('module5.slide4.heading1')"></h1>
          </div>
        </transition>
        <transition name="scale" appear>
          <div class="delay-2" v-show="slideIndex == 3">
            <h1 class="heading2">{{ $t("module5.slide4.heading2") }}</h1>
          </div>
        </transition>
        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 3" class="delay-3">
            <p class="para2">{{ $t("module5.slide4.paragraph2") }}</p>
          </div>
        </transition>

        <transition name="scale" appear>
          <a
            :href="pdfFile"
            class="download delay-6"
            v-show="slideIndex == 3"
            target="_blank"
          >
            <img src="@/assets/module5/slide4/print_btn.png" />
          </a>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdfFile:
        window?.CF_EBOOK_VARS?.documents?.book_5_document_1?.url ||
        "../Week-5-Activity-Cutout-Time-COLOUR-Asset-35.pdf",
      pdfId:
        window?.CF_EBOOK_VARS?.documents?.book_5_document_1?.document_id ||
        "test_id"
    };
  },
  props: {
    slideIndex: { type: Number }
  },
  methods: {}
};
</script>
